export default __webpack_public_path__ + "static/media/316.9e443f63.png";